<template>
    <Vue100vh ref="basePage" class="info base-page">
        <CircleWrap @click.native="goBack" type="back">
            <BackIconThin/>
        </CircleWrap>
        <div class="top">
            <div class="shadow"></div>
            <div class="stripes"></div>
        </div>
        <div class="content-wrap">
            <transition name="slide-fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
    </Vue100vh>
</template>

<script>
	import Vue100vh from 'vue-div-100vh'
    import gsap from 'gsap'
    import CircleWrap from "@/components/CircleWrap"
	import BackIconThin from "@/assets/icons/back-thin.svg"
    export default {
	    name: "Sider.vue",
	    watch:{
		    $route (to, from){
		    	let that = this
		    	setTimeout(function(){
				    that.$refs['basePage'].$el.scrollTop = 0
                }, 350)
		    }
	    },
	    mounted(){
		    // Animation
		    let tl = gsap.timeline();
		    tl.to(".info .top", {delay: 0.5, y: 0, opacity: 1, duration: 0.3});
		    tl.to(".info .circle", {x: 0, opacity: 1, duration: 0.3});
		    tl.to(".info .content-wrap", {y: 0, opacity: 1, duration: 0.5, ease: 'power2.easeOut'});
	    },
        methods: {
	    	goBack(){
	    		this.$router.go(-1)
            }
        },
        components: {
	        Vue100vh,
	    	CircleWrap,
            BackIconThin
	    }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_base-page";
    .info{
        .top{
            .stripes{
                background-color: $white;
                background-image: linear-gradient(90deg, transparent 50%, #D9D9D9 50%);
            }
        }
    }
</style>
